import ActionButton from 'components/ActionButton';
import AddShoppingListModal from 'components/AddShoppingListModal';
import BackButton from 'components/BackButton';
import { Loading } from 'components/loading/Loading';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getShoppingListDetails } from 'services/api/shoppingLists';
import { showError } from 'utils';
import BasicDetails from './basicDetails';
import styles from './index.module.scss';
import ListItems from './listItems';
import UserDetails from './userDetails';

const ShoppingListDetails = (props) => {
  const { listId } = props.match.params;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [editShoppingListModalOpen, setEditShoppingListModalOpen] = useState<boolean>(false);

  const toggleEditShoppingModalModal = () => setEditShoppingListModalOpen(!editShoppingListModalOpen);

  const getShoppingListDetailsFn = async () => {
    setLoading(true);
    try {
      const response = await getShoppingListDetails(listId);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    getShoppingListDetailsFn();
  }, []);

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Shopping List Details</div>
      <div className={styles['header-buttons']}>
        <BackButton />
        <ActionButton
          text={'Edit'}
          active={true}
          isLoading={false}
          onClick={() => {setEditShoppingListModalOpen(true)}}
        />
      </div>
    </div>
  );
      
  return(
    <div id={'main-container'} className={`${styles['main-container']}`}>
      {loading && <Loading />}
      {getHeader()}
      <BasicDetails details={data} />
      {_.get(data, 'user', undefined) ? <UserDetails userDetails={_.get(data, 'user', {})} /> : null}
      <ListItems items={_.get(data, 'items', [])} listId={listId} getShoppingListDetailsFn={getShoppingListDetailsFn} />
      {editShoppingListModalOpen && !!data && 
        <AddShoppingListModal
          list={listId}
          listDetails={data}
          toggleModal={toggleEditShoppingModalModal} 
          onSuccess={()=>{getShoppingListDetailsFn()}} 
        />
      }
    </div>
  );
};

export { ShoppingListDetails };